import styled from "styled-components";

const RegisterFormPageStyles = styled.section`
  margin: 100px auto;
  border: 1px solid #b6b6b6;
  min-width: 280px;
  width: 80%;
  max-width: 400px;
  height: 410px;
  border-radius: 20px;
  box-shadow: 10px 10px 7px #b6b6b6;
`;

export default RegisterFormPageStyles;
